import { useEffect } from 'react';
import { usePlugin } from '~/plugins/pluginContext';

interface IUseInputContainerZIndex {
    searchContainerSelector?: string;
    isInstantSearch: boolean;
    isOpen: boolean;
}

/**
 * Performs instantSearchBackdrop action - this action is necessary for clients where we use a dark backdrop behind
 * the instant search window. In most cases we want to make the search container - meaning the element containing all
 * interactive search elements - appear above the dark backdrop by setting it's z-index to a higher value than the SERP
 * backdrop.
 *
 * @param searchContainerSelector - Selector of the contianer which contains interactive search elements. Derived from
 * configuration.
 */
const useInputContainerZIndex = ({ searchContainerSelector, isInstantSearch, isOpen }: IUseInputContainerZIndex) => {
    const { doAction } = usePlugin();
    useEffect(() => {
        doAction('instantSearchInputBackdrop', {
            isInstantSearch,
            searchContainerSelector,
            isOpen,
        });
    }, [isInstantSearch, isOpen]);
};

export default useInputContainerZIndex;
